import { Form, InputGroup, Row, Col, Button } from 'react-bootstrap'
import { halfSizeImageCharacterSettingSchema } from '../../article/validateLayoutable'

type Values = {
  numberOfCharactersPerRow: number
  imageCharacters: number
  spaceCharacters: number
  textCharacters: number
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  isValid: boolean
  isSettingWritable: boolean
}

const _HalfSizeImageCharacterSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isValid,
  isSettingWritable
}: Props) => {
  return (
    <>
      <Row>
        <Col>
          <div className='text-secondary mb-2'>組版体裁・字数: {values.numberOfCharactersPerRow}字</div>
        </Col>
      </Row>
      <Form noValidate onSubmit={handleSubmit}>
        <Row sm='auto'>
          <Col sm={1}>画像字数</Col>
          <Col>
            <InputGroup size='sm' hasValidation>
              <Form.Control
                type='number'
                name='imageCharacters'
                value={values?.imageCharacters || ''}
                onBlur={handleBlur}
                onChange={handleChange}
                isInvalid={!!(touched?.imageCharacters && errors?.imageCharacters)}
                disabled={!isSettingWritable}
              />
              <InputGroup.Text>字</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors?.imageCharacters}</Form.Control.Feedback>
            </InputGroup>
          </Col>
        </Row>
        <Row sm='auto'>
          <Col sm={1}>空白字数</Col>
          <Col>
            <InputGroup size='sm' hasValidation>
              <Form.Control
                type='number'
                name='spaceCharacters'
                value={values?.spaceCharacters || ''}
                readOnly
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!(touched?.spaceCharacters && errors?.spaceCharacters)}
                disabled={!isSettingWritable}
              />
              <InputGroup.Text>字</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors?.spaceCharacters}</Form.Control.Feedback>
            </InputGroup>
          </Col>
        </Row>
        <Row sm='auto'>
          <Col sm={1}>記事字数</Col>
          <Col>
            <InputGroup size='sm' hasValidation>
              <Form.Control
                type='number'
                name='textCharacters'
                value={values?.textCharacters || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!(touched?.textCharacters && errors?.textCharacters)}
                disabled={!isSettingWritable}
              />
              <InputGroup.Text>字</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors?.textCharacters}</Form.Control.Feedback>
            </InputGroup>
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <Button
              type='submit'
              disabled={!isSettingWritable || !isValid || Object.keys(touched).length === 0}
              size='sm'
            >
              更新
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export const HalfSizeImageCharacterSettingForm = Object.assign(_HalfSizeImageCharacterSettingForm, {
  schema: halfSizeImageCharacterSettingSchema
})
